/**
 * The localStorage key set while this browser holds a mirror: the database
 * opened here, and no sign-out has wiped it since. `db.ts` opens SQLite at
 * once when it is set, and the build's inline script in index.html preloads
 * SQLite's two files for it (`vite.config.ts`).
 */
export const MIRROR_HINT = 'alluzo.mirror';
